module.exports = __webpack_public_path__ + "img/exportar.6bc7e3a3.svg";